import React from 'react';

export function Badge({ state }: { state: string }) {
    const styles: Record<string, string> = {
        ACTIVE: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
        OWNED_UNPAID: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
        EXPIRED: 'bg-red-500/10 text-red-400 border-red-500/20',
        AVAILABLE: 'bg-neutral-800 text-neutral-400 border-neutral-700',
    };
    return (
        <span
            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-bold text-[10px] uppercase ${styles[state] || styles['AVAILABLE']}`}
        >
            {state}
        </span>
    );
}
